import {
  FileX,
  TextAlignLeft,
  UsersThree,
} from "@phosphor-icons/react";
import { Reveal } from "./Reveal";

const PROBLEMS = [
  {
    icon: FileX,
    title: "Incomplete business information",
    copy: "Missing hours, services, or categories make customers guess — and guessing customers move on to the next listing.",
  },
  {
    icon: TextAlignLeft,
    title: "Weak or missing service descriptions",
    copy: "If your services aren't clearly described, Google can't match you to the searches that matter most to your business.",
  },
  {
    icon: UsersThree,
    title: "A profile that doesn't stand out",
    copy: "When every listing looks the same, customers default to whoever looks most established. Don't let that be your competitor.",
  },
];

export const Problem = () => (
  <section
    id="problem"
    data-testid="problem-section"
    className="py-24 sm:py-32"
  >
    <div className="mx-auto max-w-7xl px-6 sm:px-8 lg:px-12">
      <Reveal>
        <p className="eyebrow mb-5">The Problem</p>
        <h2 className="max-w-3xl text-4xl font-extrabold tracking-tight text-ink sm:text-5xl">
          Your Next Customer Might Never Visit Your Website.
        </h2>
        <p className="mt-6 max-w-2xl text-base text-soot sm:text-lg">
          People searching for local businesses often compare options directly
          on Google Maps. They look at your reviews, photos, services, hours,
          and business information before deciding who to contact. If your
          profile doesn't clearly explain why they should choose you, you may
          be missing opportunities.
        </p>
      </Reveal>
      <div className="mt-14 grid grid-cols-1 gap-8 md:grid-cols-3">
        {PROBLEMS.map((p, i) => (
          <Reveal key={p.title} delay={i * 0.12}>
            <div
              data-testid={`problem-card-${i + 1}`}
              className="card-surface h-full p-8 transition-[transform,box-shadow] duration-300 hover:-translate-y-1 hover:shadow-[0_16px_40px_rgb(0,0,0,0.07)] sm:p-10"
            >
              <p.icon size={40} weight="duotone" className="text-pine" />
              <h3 className="mt-6 text-2xl font-bold tracking-tight text-ink">
                {p.title}
              </h3>
              <p className="mt-3 text-base text-soot">{p.copy}</p>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
